const AUTH_PREFIX = '/api/auth';
const USERS_PREFIX = '/api/users';

export const AUTH_PATH_SEGMENTS = {
  LOGIN: 'login',
  LOG_IN: 'logIn',
  REGISTER: 'register',
  LOGOUT: 'logout',
  LOGOUT_ALL: 'logout-all',
  REFRESH: 'refresh',
  LOG_IN_GOOGLE: 'logInOrSignUpViaGoogle',
  LOG_IN_LINKEDIN: 'logInOrSignUpViaLinkedIn',
  LOG_IN_AND_JOIN: 'logInAndJoinToCourse',
  REGISTER_AND_JOIN: 'registerAndJoinToCourse',
  FORGOT_PASSWORD: 'forgotPassword',
  RESET_PASSWORD: 'resetPassword',
  CHANGE_PASSWORD: 'changePassword',
  CSRF_TOKEN: 'csrf-token',
  CHECK_EXPIRY: 'check-expiry'
} as const;

export const API_PATHS = {
  AUTH_PREFIX,
  USERS_PREFIX,
  AUTH_CSRF: `${AUTH_PREFIX}/${AUTH_PATH_SEGMENTS.CSRF_TOKEN}`,
  AUTH_REFRESH: `${AUTH_PREFIX}/${AUTH_PATH_SEGMENTS.REFRESH}`,
  AUTH_LOGOUT: `${AUTH_PREFIX}/${AUTH_PATH_SEGMENTS.LOGOUT}`,
  AUTH_CHECK_EXPIRY: `${AUTH_PREFIX}/${AUTH_PATH_SEGMENTS.CHECK_EXPIRY}`,
  AUTH_LOG_IN: `${AUTH_PREFIX}/${AUTH_PATH_SEGMENTS.LOG_IN}`,
  AUTH_REGISTER: `${AUTH_PREFIX}/${AUTH_PATH_SEGMENTS.REGISTER}`,
  USERS_CURRENT: `${USERS_PREFIX}/current`,
  CONFIG: '/api/config',
  COURSES_JOIN_STATUS: '/api/courses/join/status'
} as const;

export const AUTH_CSRF_PATH = API_PATHS.AUTH_CSRF;
export const AUTH_REFRESH_PATH = API_PATHS.AUTH_REFRESH;
export const USERS_CURRENT_PATH = API_PATHS.USERS_CURRENT;
export const CONFIG_PATH = API_PATHS.CONFIG;
export const COURSES_JOIN_STATUS_PATH = API_PATHS.COURSES_JOIN_STATUS;
